import React, { useState, useEffect } from "react";
import {
  getCustomerGroups,
  createCustomerGroup,
  // updateCustomerGroup,
  deleteCustomerGroup,
} from "../../services/customerGroupService";
import toast from "react-hot-toast";

const CustomerGroupManagement = () => {
  const [groups, setGroups] = useState([]);
  const [newGroup, setNewGroup] = useState({ group_name: "", description: "" });

  // Fetch all groups on component mount
  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    try {
      const groups = await getCustomerGroups();
      setGroups(groups.data);
    } catch (error) {
      console.error("Error fetching groups:", error.message);
      toast.error("Failed to fetch customer groups");
    }
  };

  const handleCreateGroup = async () => {
    try {
      await createCustomerGroup(newGroup);
      toast.success("Customer group created successfully!");
      setNewGroup({ group_name: "", description: "" });
      fetchGroups();
    } catch (error) {
      console.error("Error creating group:", error.message);
      toast.error("Failed to create group");
    }
  };

  // const handleUpdateGroup = async (id) => {
  //   try {
  //     await updateCustomerGroup(id, {
  //       group_name: "Updated Group",
  //       description: "Updated Description",
  //     });
  //     toast.success("Customer group updated successfully!");
  //     fetchGroups();
  //   } catch (error) {
  //     console.error("Error updating group:", error.message);
  //     toast.error("Failed to update group");
  //   }
  // };

  const handleDeleteGroup = async (id) => {
    try {
      await deleteCustomerGroup(id);
      toast.success("Customer group deleted successfully!");
      fetchGroups();
    } catch (error) {
      console.error("Error deleting group:", error.message);
      toast.error("Failed to delete group");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 flex flex-col items-center">
      <div className="bg-white shadow-md rounded-lg w-full max-w-4xl p-6">
        <h1 className="text-2xl font-bold mb-4 text-center">Customer Groups</h1>
        
        {/* Create New Group */}
        <div className="mb-6">
          <input
            type="text"
            placeholder="Group Name"
            value={newGroup.group_name}
            onChange={(e) => setNewGroup({ ...newGroup, group_name: e.target.value })}
            className="w-full px-4 py-2 mb-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
          <input
            type="text"
            placeholder="Description"
            value={newGroup.description}
            onChange={(e) => setNewGroup({ ...newGroup, description: e.target.value })}
            className="w-full px-4 py-2 mb-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
          <button
            onClick={handleCreateGroup}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200"
          >
            Create Group
          </button>
        </div>

        {/* List of Groups - Grid View */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {groups.map((group) => (
            <div
              key={group.group_id}
              className="p-4 bg-gray-50 shadow-sm rounded-lg flex flex-col justify-between"
            >
              <div>
                <p className="font-bold text-lg">{group.group_name}</p>
                <p className="text-sm text-gray-600">{group.description}</p>
              </div>
              <div className="flex space-x-2 mt-4">
               
                <button
                  onClick={() => handleDeleteGroup(group.group_id)}
                  className="px-3 py-1 text-sm text-white bg-red-500 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerGroupManagement;
